import Freezer from 'freezer-js';

export var AppStore = new Freezer({

	masterLoading: false
});

AppStore.on('Cart.AfterUpdate', function () {
	console.log('cart_afreupdate');

});

AppStore.on('Master.Load', function () {
	console.log('Master Load');

});

AppStore.on('User.ChangeLogin', function () {
	console.log('User.ChangeLogin');
});

AppStore.on('Cart.AddingProduct', function (product) {
	console.log('User.AddingProduct');
});






